import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { API_URLS } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { deleteAPI } from '../api/api';
import { showToast } from '../components/utils/toast';

const deleteProfilePicture = async (): Promise<void> => {
  return deleteAPI(API_URLS.UPLOAD_PROFILE_PICTURE);
};

export const useDeleteProfilePicture = (): UseMutationResult<
  void,
  AxiosError<{ message?: string; type?: string }>
> => {
  const { setIsLoading } = useLoading();

  return useMutation({
    mutationFn: deleteProfilePicture,
    onMutate: () => {
      setIsLoading(true);
    },
    onError: (error) => {
      showToast('error', error.message);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
